import "./home.css";
import Poster from "./poster/Poster";
import Brands from "./Brands";
import Categories from "./Categories";
import HotSale from "./HotSale";
import { Link, useParams } from "react-router-dom";
import { useState, useLayoutEffect } from "react";
import { getbymain } from "../../network/api/subcategory";
import NewProduct from "./new/NewProduct";
import FlashStyle from "./FlashStyle/FlashStyle.jsx";
import TodayOffer from "./TodayOffer/TodayOffer";
import BrandsCompany from "./brands/BrandsCompany";
import DistinctiveProducts from "./DistinctiveProducts/DistinctiveProducts";
import MoBImg from "./Images/mob.png";
// import ShopByCategory from './ShopByCategory.js';
import ShopBycategoryModification from "./FlashStyle/ShopBycategoryModification";
import axios from "axios";
import { link } from "../../config.js";

function Home(props) {
  let { id } = useParams();
  const [subCategory, setSubCategory] = useState([]);
  const [banners, setBanners] = useState([]);
  const [bannersSubCategories, setBannersSubCategories] = useState([]);
  const [webConfig, setWebConfig] = useState({});

  const getWebConfig = async () => {
    try {
      const { data } = await axios.get(`${link}web-config`);
      setWebConfig(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getSubCategories = () => {
    getbymain(id).then((result) => {
      setSubCategory(result?.data);
    });
  };
  const getBannersFunc = async () => {
    try {
      const { data } = await axios.get(`${link}banners-home`);
      setBanners(data.banner);
    } catch (error) {
      console.log(error);
    }
  };
  const getBannersSubCategoriesFunc = async () => {
    try {
      const { data } = await axios.get(`${link}banners/sub-category`);
      setBannersSubCategories(data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useLayoutEffect(() => {
    getSubCategories();
    getBannersFunc();
    getBannersSubCategoriesFunc();
    getWebConfig();
  }, [id]);

  if (!id) {
    // You can render a loading indicator or any other component while waiting for the data
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-warning " role="status">
          <span className="visually-hidden ">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <section className="home">
      <div className="mx-4">
        <Poster id={id} sliderBanner={banners.sliderBanner} />
        <Brands id={id} />
      </div>
      <Categories subCategory={subCategory} />
      {webConfig?.newArrivalSectionShow && (
        <NewProduct id={id} newArrival={banners.newArrival} />
      )}

      {webConfig?.flashSaleSectionShow && (
        <FlashStyle
          id={id}
          subCategory={subCategory}
          update_p={props.update_p}
          personal={props.personal}
          flashSell={banners.flashSell}
        />
      )}

      {webConfig?.todaysOffersSectionShow && (
        <TodayOffer
          id={id}
          subCategory={subCategory}
          update_p={props.update_p}
          personal={props.personal}
        />
      )}
      {webConfig?.featuredItemsSectionShow && (
        <>
          {banners.beforeSpecialItems?.images?.length > 0 && (
            <div className="brands-company">
              {banners.beforeSpecialItems?.images?.map((brand, index) => (
                <Link
                  to={brand?.link}
                  key={index}
                  className={`brand  ${index === 1 ? "middle" : "side"}`}
                  style={{ cursor: "default", border: "1px solid" }}
                >
                  <img src={brand?.secure_url} alt={`Brand ${index + 1}`} />
                </Link>
              ))}
            </div>
          )}
          <DistinctiveProducts
            id={id}
            subCategory={subCategory}
            update_p={props.update_p}
            personal={props.personal}
          />
          {banners.afterSpecialItems?.images?.length > 0 && (
            <div className="brands-company">
              {banners.afterSpecialItems?.images?.map((brand, index) => (
                 <Link
                 to={brand?.link}
                 key={index}
                 className={`brand  ${index === 1 ? "middle" : "side"}`}
                 style={{ cursor: "default", border: "1px solid" }}
               >
                 <img src={brand?.secure_url} alt={`Brand ${index + 1}`} />
               </Link>
              ))}
            </div>
          )}
        </>
      )}

      {webConfig?.shopByCategoriesSectionShow && (
        <ShopBycategoryModification
          id={id}
          subCategory={subCategory}
          update_p={props.update_p}
          personal={props.personal}
          bannersSubCategories={bannersSubCategories}
        />
      )}

      {/* <ShopByCategory id={id} subCategory={subCategory} update_p={props.update_p} personal={props.personal} /> */}
    </section>
  );
}
export default Home;
